import Helper from "./Helper";

class PrevNextPosition {
  constructor(config = {}) {
    const {
      footer,
      prevnext,
      header,
      breakPointMd
    } = config;

    this.headerheighthalf = 79;
    this.breakPointMd = breakPointMd;
    this.footer = document.querySelector(footer);
    this.header = document.querySelector(header);
    this.prevnext = document.querySelector(prevnext);
    this.portfolio = document.querySelector('.prev-next__portfolio');

    if (this.prevnext) {
      this.bindEvents();
    }
  }

  bindEvents() {
    // center the prev-next-element only, when breakpoint is over 990px
    let vw = window.innerWidth;
    let headerBottom = this.getBottomPosition(this.header);
    let footerTop = this.getTopPosition(this.footer);

    window.addEventListener('resize', () => {
      vw = window.innerWidth;
      headerBottom = this.getBottomPosition(this.header);
      footerTop = this.getTopPosition(this.footer);
      if (vw > this.breakPointMd) {
        this.centerElemWhenFooterIsInViewport(this.prevnext, headerBottom, footerTop);
      } else {
        //set the value of style to default. It's only needed, if user resize the window
        this.prevnext.style.top = 'auto';
        this.prevnext.style.transform = 'translateY(0)';
      }
    });

    window.addEventListener("scroll", () => {
      headerBottom = this.getBottomPosition(this.header);
      footerTop = this.getTopPosition(this.footer);
      if (vw > this.breakPointMd) {
        this.centerElemWhenFooterIsInViewport(this.prevnext, headerBottom, footerTop);
      }
    });

    if (vw > this.breakPointMd) {
      this.centerElemWhenFooterIsInViewport(this.prevnext, headerBottom, footerTop);
    }
  }

  centerElemWhenFooterIsInViewport(prevnext, headerBottom, footerTop) {
    if(footerTop <= (window.innerHeight || document.documentElement.clientHeight)) {
      let height = this.getHeightOfObject(prevnext);
      let pos = this.getCenterTopPositon(headerBottom, footerTop, height);
      //because the portfolio is on display none in mobile, the 50px are not countet on footer
      if(this.portfolio) {
        pos = pos - 50;
      }
      prevnext.style.top = pos + 'px';
      prevnext.style.transform = 'translateY(0)';
    } else {
      prevnext.style.transform = 'translateY(calc(calc(-50% + ' + this.headerheighthalf + 'px))';
      prevnext.style.top = '50%';
    }
  };

  getBottomPosition(elem) {
    const bounding = elem.getBoundingClientRect();
    return bounding.bottom;
  }

  getTopPosition(elem) {
    const bounding = elem.getBoundingClientRect();
    return bounding.top;
  }

  getHeightOfObject(elem) {
    const bounding = elem.getBoundingClientRect();
    return bounding.height;
  }

  getCenterTopPositon(top, bottom, heightOfObject) {
    const halfOfObj = heightOfObject / 2;
    const halfOfView = (bottom - top) / 2; //between footer and header
    return halfOfView + halfOfObj;
  }
}

export default PrevNextPosition;

